module.exports = "/packs/homebase_popup_bg-pc-8ce33e7b460ee6266af0557c0ae8a138.png";